
import { IUpdateInformation } from '@/Interface';
import ParameterInput from './ParameterInput.vue';
import InputHint from './ParameterInputHint.vue';
import Vue from 'vue';

export default Vue.extend({
	name: 'ParameterInputExpanded',
	components: {
		ParameterInput,
		InputHint,
	},
	props: {
		parameter: {
		},
		value: {
		},
		inputCustomAliare: {
			type: Boolean,
			default: false,
		},
		showValidationWarnings: {
			type: Boolean,
		},
		documentationUrl: {
			type: String,
		},
	},
	data() {
		return {
			focused: false,
			blurredEver: false,
			showInfoInput: false,
			inputHasValue: false,
		};
	},
	mounted() {
		this.verifySecretValue();
		this.$root.$on('toggleVisibilityInputCredentials', (inputName: string) => {
			if(this.$props.parameter.name == inputName) {
				this.showInfoInput = !this.showInfoInput;
				if(!this.value) {
					this.inputHasValue = !this.inputHasValue;
				}
			}
		});
		this.verifyValues();
	},
	computed: {
		showRequiredErrors(): boolean {
			if (!this.$props.parameter.required) {
				return false;
			}

			if (this.blurredEver || this.showValidationWarnings) {
				if (this.$props.parameter.type === 'string') {
					return !this.value;
				}

				if (this.$props.parameter.type === 'number') {
					return typeof this.value !== 'number';
				}
			}

			return false;
		},
	},
	methods: {
		verifySecretValue() {
			if (this.value == '[SecretValue]') {
				this.showInfoInput = true;
			}
		},
		resetValue() {
			this.inputHasValue = false;
		},
		onFocus() {
			this.focused = true;
		},
		onBlur() {
			this.blurredEver = true;
			this.focused = false;
		},
		valueChanged(parameterData: IUpdateInformation) {
			this.verifyValues(parameterData);
			this.$emit('change', parameterData);
		},
		verifyValues(data) {
			if(!!this.value || typeof data !== 'undefined' || this.showInfoInput) {
				this.inputHasValue = true;
			} else {
				this.inputHasValue = false;
			}
		},
		onDocumentationUrlClick (): void {
			this.$telemetry.track('User clicked credential modal docs link', {
				docs_link: this.documentationUrl,
				source: 'field',
				workflow_id: this.$store.getters.workflowId,
			});
		},
	},
});
